<template>
  <b-modal
    id="calendar-modal"
    modal-class="guide-modal"
    hide-footer
    hide-header
    centered
  >
    <div class="Wrap">
      <fieldset>
        <!-- <legend>Base Calendar</legend> -->
        <!-- <div>
            <p>output:</p>
            <pre>{{output}}</pre>
            <p>now: {{new Date().toLocaleDateString()}} г.</p>
            <p>clickedDay: <b>{{output.str}}</b></p>
            <p>format: <b>{{output.format}}</b></p>
        </div> -->
        <div class="flex">
          <div class="Calendar">
            <div class="Cr-Head">
              <div class="Cr-Head_ltMonth" @click="ltMonth">
                <svg
                  width="9"
                  height="14"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.2259 12.2194L1.79297 6.78644L7.2259 1.35352"
                    stroke="#474D52"
                    stroke-width="1.81098"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="Cr-Head_currMonth">
                {{ months[currMonth].slice(0, 3) }} {{ currYear }}
              </div>
              <div class="Cr-Head_gtMonth" @click="gtMonth">
                <svg
                  width="9"
                  height="14"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.77539 12.2194L7.20832 6.78644L1.77539 1.35352"
                    stroke="#474D52"
                    stroke-width="1.81098"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div class="Cr-Week">
              <div
                class="Cr-Week_day"
                v-for="day in days"
                :key="'day-' + day + 1"
              >
                {{ day }}
              </div>
            </div>
            <div class="Cr-Days">
              <div
                class="Cr-Days_blank"
                :key="'blank-' + blank + 1"
                v-for="blank in daysOfPrevMonth"
              >
                {{ blank }}
              </div>
              <div
                class="Cr-Days_day"
                v-for="i in daysInMonth"
                :class="{ currDay: i == currDay, clickedDay: i == clickedDay }"
                @click="setDate(i)"
                :key="'crday-' + i + 1"
              >
                {{ i }}
              </div>
              <div
                class="Cr-Days_blank"
                :key="'crblank-' + i + 1"
                v-for="(_, i) in qtyDaysNextMonth"
              >
                {{ i + 1 }}
              </div>
            </div>
            <hr />
            <div class="time">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.99984 1.99984C4.68613 1.99984 1.99984 4.68613 1.99984 7.99984C1.99984 11.3135 4.68613 13.9998 7.99984 13.9998C11.3135 13.9998 13.9998 11.3135 13.9998 7.99984C13.9998 4.68613 11.3135 1.99984 7.99984 1.99984ZM0.666504 7.99984C0.666504 3.94975 3.94975 0.666504 7.99984 0.666504C12.0499 0.666504 15.3332 3.94975 15.3332 7.99984C15.3332 12.0499 12.0499 15.3332 7.99984 15.3332C3.94975 15.3332 0.666504 12.0499 0.666504 7.99984Z"
                  fill="var(--theme-color)"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.99984 3.33317C8.36803 3.33317 8.6665 3.63165 8.6665 3.99984V7.58781L10.9646 8.73689C11.294 8.90154 11.4274 9.30199 11.2628 9.63131C11.0981 9.96063 10.6977 10.0941 10.3684 9.92945L7.70169 8.59612C7.47584 8.48319 7.33317 8.25235 7.33317 7.99984V3.99984C7.33317 3.63165 7.63165 3.33317 7.99984 3.33317Z"
                  fill="var(--theme-color)"
                />
              </svg>
              <input
                type="number"
                v-model="hours"
                min="1"
                max="24"
                class="form-control"
              />
              :
              <input
                type="number"
                v-model="mins"
                min="0"
                max="59"
                class="form-control"
              />

              <!-- <input
              type="text"
              v-model="period"
              class="form-control"
              @keydown.up="period = 'AM'"
              @keydown.down="period = 'PM'"

            /> -->
            </div>
            <br />
            <div class="d-flex justify-content-between">
              <button
                class="btn-simple"
                @click="$bvModal.hide('calendar-modal')"
              >
                Cancel
              </button>
              <button class="btn-round-fill" @click="addDate">
                Add
              </button>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </b-modal>
</template>

<script>
const NOW = new Date();
export default {
  mounted(){
    debugger;

  },
  computed: {
    currYear() {
      console.log("currentYear", this.inst_date.getFullYear());
      return this.inst_date.getFullYear();
    },
    currMonth() {
      return this.inst_date.getMonth();
    },
    currWD() {
      return this.inst_date.getDay();
    },
    currDay() {
      return this.inst_date.getDay();
    },
    // currDay() {
    //   // !TODO wtf
    //   if (
    //     this.inst_date.getMonth() === NOW.getMonth() &&
    //     this.inst_date.getFullYear() === NOW.getFullYear()
    //   ) {
    //     return NOW.getDate();
    //   }
    // },
    daysInMonth() {
      return new Date(this.currYear, this.currMonth + 1, 0).getDate();
    },
    _lastDateOfPrevMonth() {
      return new Date(this.currYear, this.currMonth, 0).getDate();
    },
    _qtyDaysPrevMonth() {
      return new Date(this.currYear, this.currMonth, 0).getDay();
    },
    daysOfPrevMonth() {
      return (
        this._qtyDaysPrevMonth &&
        Array.from(
          { length: this._qtyDaysPrevMonth },
          (v, k) => this._lastDateOfPrevMonth - this._qtyDaysPrevMonth + (k + 1)
        )
        /*
        Array.from(
          { length: this._qtyDaysPrevMonth },
          (v, k) => this._lastDateOfPrevMonth - k
        ).reverse()
        */
      );
    },
    qtyDaysNextMonth() {
      return 42 - (this.daysInMonth + this._qtyDaysPrevMonth);
    }
  },
  methods: {
    addDate() {
      this.$emit("updateDate", {
        date: this.output,
        time: this.hours + ":" + this.mins
      });
    },
    ltMonth() {
      this.clickedDay = null;
      // this.clickedDay && this.reset()
      this.inst_date = new Date(this.currYear, this.currMonth - 1);
    },
    gtMonth() {
      this.clickedDay = null;
      // this.clickedDay && this.reset()
      this.inst_date = new Date(this.currYear, this.currMonth + 1);
    },
    reset() {
      this.clickedDay = null;
      // this.output.str = ''
      this.$emit("setdate", null);
    },
    setDate(day) {
      this.clickedDay = day;

      const fixDay = day < 10 ? "0" + day : day;
      const fixMonth =
        this.currMonth + 1 < 10
          ? "0" + (this.currMonth + 1)
          : this.currMonth + 1;

      this.output.str = `${day} ${this.months[this.currMonth]} ${
        this.currYear
      }`;
      this.output.format = `${this.currYear}-${fixMonth}-${fixDay}`;

      this.$emit("setdate", this.output);
    }
  },
  data() {
    return {
      inst_date: NOW,
      days: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      // period: "AM",
      clickedDay: null,
      output: {
        str: "", //19 Апр 2018
        format: "" //2018-04-19
      },
      hours: "12",
      mins: "00"
      // period: 'AM'
    };
  }
};
</script>

<style lang="scss" scoped>
.btn-simple {
  background: #f3f6f9;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
  border-radius: 100px;
  border: none;
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #474d52;
}
.btn-round-fill {
  width: 120px;
}
.flex {
  display: flex;
}
.Calendar {
  border-radius: 9px;
  margin: auto;
  // box-shadow: 0 0 20px rgba(51, 51, 51, 0.5);
  width: 330px;
  text-align: center;
  user-select: none;
  padding: 20px;
}
.Cr-Head {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.Cr-Head,
.Cr-Week,
.Cr-Days {
  display: flex;
}
.Cr-Head,
.Cr-Week {
  font-weight: bold;
}
.Cr-Week {
  line-height: 2em;
}
.Cr-Week_day {
  width: 40px;
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 14px;

  text-transform: uppercase;

  /* Secondary */

  color: #8d99a0;
}
.Cr-Head {
  background: #fff;
  color: #474d52;
  /* justify-content: space-between; */
  line-height: 40px;
}
.Cr-Head_currMonth {
  /* flex: 1; */
}
.Cr-Head_ltMonth,
.Cr-Head_gtMonth {
  cursor: pointer;
  width: 40px;
}
.Cr-Head_ltMonth:hover,
.Cr-Head_gtMonth:hover {
  /* background: var(--theme-color); */
}
.Cr-Days {
  flex-wrap: wrap;
  line-height: 40px;
}
.Cr-Days_blank,
.Cr-Days_day {
  width: 40px;
}
.Cr-Days_blank {
  color: #dee2e6;
}
.Cr-Days_day {
  cursor: pointer;
  border-radius: 50%;
  margin: 7px 0;
}
.Cr-Days_day:hover:not(.currDay):not(.clickedDay) {
  background: #dee2e6;
}
.Cr-Days .currDay {
  background: #ccc;
  position: relative;
}
.Cr-Days .clickedDay {
  color: #fff;
  font-weight: bold;
  background: var(--theme-color);
}
.time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  input {
    width: 102px;
    text-align: center;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 24px;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
